/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { HelperService } from '../../../services/helper/helper.service';
import { LessonInterface } from '../../../models/interface/lesson.interface';
import { AnswersheetInterface } from '../../../models/interface/answersheet.interface';
import { AnswersheetAnswerInterface } from '../../../models/interface/answersheet-answer.interface';
import { AnswersheetsStore } from '../../../store/answersheet/component-store/answersheet.store';
import { QuestionnaireStore } from '../../../store/lesson-questionnaire/component-store/lesson-questionnaire.store';
import { DiaryInterface } from 'src/app/models/interface/diary.interface';

/**
 * Component:
 * Displays the answersheet details of a diary;
 */
@Component({
  selector: 'app-diary-answersheets-detail',
  templateUrl: './diary-answersheets-detail.component.html',
  styleUrls: ['./diary-answersheets-detail.component.scss'],
  providers: [AnswersheetsStore, QuestionnaireStore],
})
export class DiaryAnswersheetsDetailComponent implements OnInit, OnDestroy {
  // Icon
  faArrowLeft = faArrowLeft;
  faArrowRight = faArrowRight;
  faChevronUp = faChevronUp;
  faChevronDown = faChevronDown;

  public isLoading$: Observable<boolean>;
  public isCollapse$: Observable<boolean>;

  public questionnaireId: number;
  public answers: AnswersheetAnswerInterface[] = [];

  public lesson: LessonInterface;

  public diary: DiaryInterface;

  public backgroundColor: string;
  public diaryBackgroundImageColor: string;

  public param = { intervention_name: '' };

  public studyId: number;

  private questionnaire$: Observable<LessonInterface>;

  private isLoadingSubject = new BehaviorSubject<boolean>(true);

  private subscriptions: Subscription[] = [];

  constructor(
    private helperService: HelperService,
    private questionnaireStore: QuestionnaireStore,
  ) {
    this.isLoading$ = this.isLoadingSubject.asObservable();
    this.questionnaire$ = this.questionnaireStore.questionnaire$;
  }

  public get helper() {
    return this.helperService;
  }

  @Input()
  set _answersheet(_answersheet: AnswersheetInterface) {
    if (_answersheet) {
      this.answers = _answersheet.attributes.answers;
      this.questionnaireId = _answersheet.attributes.questionnaire_id;
    }
  }

  @Input()
  set _study_id(_studyId: number) {
    this.studyId = _studyId;
  }

  @Input()
  set _diaryBackground(_diaryBackground: string) {
    this.diaryBackgroundImageColor = _diaryBackground;
    this.backgroundColor = _diaryBackground;
  }

  @Input()
  set _diary(_diary: DiaryInterface) {
    this.diary = _diary;
  }

  ngOnInit(): void {
    this.questionnaireStore.getQuestionnaireDetails({
      questionnaireId: this.questionnaireId,
    });
    this.subscriptions.push(
      this.questionnaire$.subscribe((result) => {
        this.lesson = result;
        this.isLoadingSubject.next(false);
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
